import { ConfigurationType } from '../dependencies/types';
import {
  BaseElementProperties,
  BaseFieldProperties,
  ApexClassProperties,
  ApexTriggerProperties,
  ApprovalProcessProperties,
  FlowProperties,
  LayoutProperties,
  RecordTypeProperties,
  ValidationRuleProperties,
  WorkflowRuleProperties,
} from '@server/documentation';
import { ConfigurationItem, NameProperties } from '../../parser/ParserTypes';

export enum SearchType {
  apiNameAndLabel = 'NAME_LABEL_SEARCH',
  content = 'CONTENT_SEARCH',
}

// TODO SWEEP-8083 - remove and use the flat types or create new grouped types with no keys in @server/documentation
export type SearchResponse = {
  //should be the same as BE
  [ConfigurationType.apexClasses]: ApexClassProperties[];
  [ConfigurationType.apexTriggers]: ApexTriggerProperties[];
  [ConfigurationType.approvalProcesses]: ApprovalProcessProperties[];
  [ConfigurationType.fields]: BaseFieldProperties[];
  [ConfigurationType.flows]: FlowProperties[];
  [ConfigurationType.objects]: NameProperties[];
  [ConfigurationType.processBuilderFlows]: FlowProperties[];
  [ConfigurationType.validationRules]: ValidationRuleProperties[];
  [ConfigurationType.workflowRules]: WorkflowRuleProperties[];
  [ConfigurationType.layouts]: LayoutProperties[];
  [ConfigurationType.recordTypes]: RecordTypeProperties[];
  [ConfigurationType.others]: BaseElementProperties[];
};

export type SearchResponseWithConfigurationItems = {
  [ConfigurationType.apexClasses]: ConfigurationItem[];
  [ConfigurationType.apexTriggers]: ConfigurationItem[];
  [ConfigurationType.approvalProcesses]: ConfigurationItem[];
  [ConfigurationType.fields]: ConfigurationItem[];
  [ConfigurationType.flows]: ConfigurationItem[];
  [ConfigurationType.objects]: ConfigurationItem[];
  [ConfigurationType.processBuilderFlows]: ConfigurationItem[];
  [ConfigurationType.validationRules]: ConfigurationItem[];
  [ConfigurationType.workflowRules]: ConfigurationItem[];
  [ConfigurationType.layouts]: ConfigurationItem[];
  [ConfigurationType.recordTypes]: ConfigurationItem[];
  [ConfigurationType.others]: ConfigurationItem[];
};

export type MatchData = { filename: string; match: string };

type ConfigurationBaseMatchProperties = BaseElementProperties & MatchData;

export type ContentSearchResponse = {
  [key in keyof SearchResponse]: (SearchResponse[key][number] & MatchData)[];
} & {
  files?: ConfigurationBaseMatchProperties[];
  unclassifiedConfigurations: ConfigurationBaseMatchProperties[];
};
